import React from 'react'
import { useTranslation } from 'react-i18next'

import crashImg from '@/shared/assets/img/svg/crashed_block_placeholder.svg'

import EmptyState from './EmptyState'

export default function FallbackError() {
	const { t } = useTranslation()

	return (
		<div className='my-2.50 flex flex-auto items-center justify-center'>
			<EmptyState
				imageUrl={crashImg}
				imgClasses='h-52'
				wrapperClasses='fade-in'
			>
				<div className='text-center'>
					<p className='text-lg font-bold'>{t('fatal_error_title')}🐞</p>
					<p className='text-muted-foreground'>{t('fatal_error_desc')}</p>
				</div>
			</EmptyState>
		</div>
	)
}
